import type React from 'react'
import ReactMarkdown from 'react-markdown'
import remarkBreaks from 'remark-breaks'
import remarkGfm from 'remark-gfm'

type Props = {
  content: string
}

// remarkGfm: 素の URL をそのまま書いてもリンクになる（テーブルや打ち消し線も解釈される）
// remarkBreaks: 単一の改行をそのまま改行として表示する（Markdown の既定では前の行に繋がってしまう）
const remarkPlugins = [remarkGfm, remarkBreaks]

export const MarkdownContent: React.FC<Props> = ({ content }) => {
  return (
    <ReactMarkdown
      remarkPlugins={remarkPlugins}
      allowedElements={[
        'p',
        'br',
        'strong',
        'em',
        'del',
        'a',
        'text',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'ul',
        'ol',
        'li',
        'table',
        'thead',
        'tbody',
        'tr',
        'th',
        'td',
      ]}
      unwrapDisallowed
      components={{
        a: ({ href, children }) => {
          // href がない場合はただのテキスト
          if (!href) {
            return <>{children}</>
          }

          // http / https のみリンクとして扱う
          if (/^https?:\/\//.test(href)) {
            return (
              <a href={href} target="_blank" rel="noopener noreferrer">
                {children}
              </a>
            )
          }

          // アプリ内リンク / 相対パスなどは無視
          return <>{children}</>
        },
      }}
    >
      {content}
    </ReactMarkdown>
  )
}
